module.exports = __webpack_public_path__ + "static/img/end.1f8a51c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Waving/end.jpg
// module id = Jfop
// module chunks = 1